import { render, staticRenderFns } from "./InterCommDiscFactorReview.vue?vue&type=template&id=1c779de8&"
import script from "./InterCommDiscFactorReview.vue?vue&type=script&lang=js&"
export * from "./InterCommDiscFactorReview.vue?vue&type=script&lang=js&"
import style0 from "./InterCommDiscFactorReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InterCommDiscFactorReview.vue"
export default component.exports